import { mdiChevronRight } from "@mdi/js";
import { For, createMemo } from "solid-js";
import { Buis } from "~/components/Buis";
import { Card, CardDescription } from "~/components/ui/card";
import { Group } from "~/components/ui/group";
import { Icon } from "~/components/ui/icon";
import { Stack } from "~/components/ui/stack";
import { cn } from "~/util/utils";
import { useDocumentContext } from "../../../providers/context";
import type { Article } from "../../../types";
import { matchSearch } from "../helpers";

export function DocumentBookmarksMobile() {
	const { articles, searches, bookmarks: bookmarksArray, setSelected, selected, setSheetOpen } = useDocumentContext();

	const filteredArticles = createMemo(() => {
		const arts = articles();
		const searched = searches();
		const marks = bookmarksArray();

		const bookmarks = arts.filter((article) => marks.has(article.id));

		if (searched.length === 0) {
			return bookmarks;
		}

		return bookmarks.filter((article) => {
			return matchSearch(searched, [article.title, article.content, article.tocSubtitle]);
		});
	});

	const onSelectBookmarkArticle = (item: Article) => {
		setSelected(item);
		setSheetOpen(false);
	};

	return (
		<Stack class="p-4 lg:p-0">
			<For each={filteredArticles()}>
				{(item) => (
					<Card
						class={cn(
							"w-full transition-all p-4 relative cursor-pointer",
							"data-[selected='true']:border-l-[5px] data-[selected='true']:border-l-accent",
							"lg:hover:bg-gray-50 lg:active:bg-gray-100",
						)}
						data-selected={selected()?.id === item.id}
						onClick={() => onSelectBookmarkArticle(item)}
					>
						<Group>
							<div class="flex-1">
								<CardDescription class="text-gray-600 line-clamp-2 mb-1 text-xs">
									<Buis value={item.breadcrumb} />
								</CardDescription>
								<CardDescription class="text-black line-clamp-2">
									<Buis value={item.title} />
								</CardDescription>
							</div>
							<Icon
								class="ml-auto"
								path={mdiChevronRight}
							/>
						</Group>
					</Card>
				)}
			</For>
		</Stack>
	);
}
